var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeasesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39833 39.8469C9.39833 41.9439 11.0974 43.648 13.1995 43.648C15.2966 43.648 17.0007 41.949 17.0007 39.8469C17.0007 37.75 15.3017 36.0459 13.1995 36.0459C11.1025 36.051 9.39833 37.75 9.39833 39.8469Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0016 33.9694V45C38.0016 46.6582 36.6598 48 35.0015 48H7.00027C5.34203 48 4.00013 46.6582 4.00013 45V7C4.00013 5.34184 5.34203 4 7.00027 4H35.0015C36.6598 4 38.0016 5.34184 38.0016 7V17.5255L41.0018 13.2551V5C41.0018 2.79082 39.2109 1 37.0016 1H5.00018C2.7909 1 1 2.79082 1 5V47C1 49.2092 2.7909 51 5.00018 51H37.0016C39.2109 51 41.0018 49.2092 41.0018 47V29.7041L38.0016 33.9694Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 10.9031H34.0015V13.301H8.00031V10.9031Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 25.898H32.1137L33.8025 23.5H8.00031V25.898Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00031 17.199H34.0015V19.5969H8.00031V17.199Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5481 15.0459L50.6808 13.4286C51.2114 12.6684 51.0737 11.6531 50.3185 11.1224L47.5837 9.20918C46.8235 8.67857 45.752 8.84694 45.2214 9.60714L44.0887 11.2245L49.5481 15.0459Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5317 36.2704L26.5113 42.148L32.032 40.1173L26.5317 36.2704Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6295 11.8673L26.9246 35.7143L32.3892 39.5408L49.094 15.6939L43.6295 11.8673ZM31.0728 34.4337L30.6136 34.1122L43.4407 15.8061L43.8999 16.1276L31.0728 34.4337ZM32.7463 35.5714L32.3024 35.2602L45.0989 16.9949L45.5428 17.3061L32.7463 35.5714Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3983 74.8469C58.3983 76.9439 60.0974 78.648 62.1995 78.648C64.2966 78.648 66.0007 76.949 66.0007 74.8469C66.0007 72.75 64.3017 71.0459 62.1995 71.0459C60.1025 71.051 58.3983 72.75 58.3983 74.8469Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0016 68.9694V80C87.0016 81.6582 85.6598 83 84.0015 83H56.0003C54.342 83 53.0001 81.6582 53.0001 80V42C53.0001 40.3418 54.342 39 56.0003 39H84.0015C85.6598 39 87.0016 40.3418 87.0016 42V52.5255L90.0018 48.2551V40C90.0018 37.7908 88.2109 36 86.0016 36H54.0002C51.7909 36 50 37.7908 50 40V82C50 84.2092 51.7909 86 54.0002 86H86.0016C88.2109 86 90.0018 84.2092 90.0018 82V64.7041L87.0016 68.9694Z",
    fill: "#F7931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0003 45.9031H83.0015V48.301H57.0003V45.9031Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0003 60.898H81.1137L82.8025 58.5H57.0003V60.898Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0003 52.199H83.0015V54.5969H57.0003V52.199Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5481 50.0459L99.6808 48.4286C100.211 47.6684 100.074 46.6531 99.3185 46.1225L96.5837 44.2092C95.8235 43.6786 94.752 43.8469 94.2214 44.6071L93.0887 46.2245L98.5481 50.0459Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5317 71.2704L75.5113 77.148L81.032 75.1173L75.5317 71.2704Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6295 46.8673L75.9246 70.7143L81.3892 74.5408L98.094 50.6939L92.6295 46.8673ZM80.0728 69.4337L79.6136 69.1122L92.4407 50.8061L92.8999 51.1276L80.0728 69.4337ZM81.7463 70.5714L81.3024 70.2602L94.0989 51.9949L94.5428 52.3061L81.7463 70.5714Z",
    fill: "#F7931E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasesIcon);
export default __webpack_public_path__ + "static/media/LeasesIcon.cdfcd55926f74f48ca251ca46c5813bb.svg";
export { ForwardRef as ReactComponent };